var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoggedIn)?_c('side-nav'):_vm._e(),_c('v-main',{attrs:{"id":"main"}},[(_vm.isLoggedIn)?_c('top-nav'):_vm._e(),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('change-password',{attrs:{"dialog":_vm.dialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }